<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import { removeProduct , addProduct } from '../base/products.js';
    import { systemUrl } from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    export let items = [];
    export let filters = [];

    onMount(async() => {        
      

    });


    const removeProductAction = async(item)=>{
      let result = await removeProduct(item)
      if (result) {
        item.merchant_product_id = 0;
      }
      items = items;
    }

    const addProductAction = async(item)=>{
      let result = await addProduct(item)
      if (result) {
        item.merchant_product_id = 1;
      }
      items = items;
    }


    // const removeProduct = async(item) => {

    //   let postData = {};
    //   postData.action = 'remove_product';
    //   postData.token  = $UserStore.token
    //   postData.id     = item.id;
    //   let response = await fetchData(postData);
    //   if (response.success==1) {
    //     item.merchant_product_id = 0; 
    //     items = items;          
    //   }

    // }

    // const addProduct = async(item) => {
    //   let postData = {};
    //   postData.action = 'add_product';
    //   postData.token  = $UserStore.token
    //   postData.id     = item.id;
    //   let response = await fetchData(postData);
    //   if (response.success==1) {
    //     item.merchant_product_id = 1;
    //     items = items;            
    //   }
    // }

</script>

<div class="grid-items">
  {#each items as item,index}
  <div class="item">
        <div class="image"><img src="{item.image}" alt=""></div>
    <div class="name">{item.name}</div>
    {#if item.options!='' && Object.keys(item.options).length>0}
    <div class="options">
      {#each Object.entries(item.options) as [key, option]}
        <div>{key} - {option}</div>
      {/each}
    </div>
    {/if}
    <div class="divider"></div>
    <div class="item-bottom">
      <!-- <div class="profit">{item.price - item.drop_price } {$_('products.profit')}</div> -->
      <div class="prices">
        <div class="drop-price">
          <div class="title">{$_('products.commision')}</div>
          <div class="amount">{ item.fee_amount }</div>
        </div>      
        <div class="price">
          <div class="title">{$_('products.selling_price')}</div>
          <div class="amount">{item.price}</div>        
        </div>
      </div>
      <div class="actions">
        {#if item.merchant_product_id > 0}
        <button on:click={()=> { removeProductAction(item) }} class="remove">{$_('products.remove_product')}</button>
        {:else}
        <button on:click={()=> { addProductAction(item) }}>{$_('products.add_product')}</button>
        {/if}
      </div>
    </div>
  </div>
  {/each}
</div>
<style>
  .grid-items {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); /* Creates flexible grid columns */
    /* grid-gap: 20px; */
    background-color: #fff;
  }
  .item {
    display: flex;
    flex-direction: column;
    font-size:14px;
    border: 1px solid #f1f1f1;
    padding-bottom:86px;
    position: relative;
    
  }
  .name {
    text-align: center;
    margin-bottom: 5px;;
  }
  .options {
    text-align: center;
    margin-bottom: 5px;;
  }
  .divider {
    height: 10px;;
  }
  .item-bottom {
    position: absolute;
    bottom:0;
    width: 100%;;
  }
  .prices {
    display: flex;
    font-size: 12px;;
  }
  .prices > div {
    flex:1;
    flex-direction: column;
    text-align: center;
    background-color: var(--blue-color) ;
    color: #fff;
    padding: 5px;
  }
  .prices > div.price {
    background-color: #04368f;
  }
  .image img{
    width:100%
  }
  
  button {
    background-color: var(--blue-color) ;
    color: #fff;
    width: 100%;
    padding:10px 0;
    text-align: center;
    border:0;
    border-top:1px solid #0042b9;
    cursor: pointer;
  }
  button:hover {
    background-color: var(--blue-color-hover) ;
  }
  button.remove {
    border-top-color: #c00000;;
    background-color: #900000;
  }
  button.remove:hover {
    background-color: #800000;
  }
  .profit {
    background-color:  var(--blue-color) ;
    color: #fff;
    padding: 2px 10px;
    font-size: 11px;
    text-align: center;
    border-bottom:1px solid #0042b9;
  }
</style>